module.exports = __webpack_public_path__ + "img/close.3b474601.png";